import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function HeroSection() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/series?q=${encodeURIComponent(q)}` : "/series");
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20anime%20cityscape%20at%20golden%20hour%20with%20floating%20light%20particles%20and%20distant%20mountains%2C%20vibrant%20warm%20orange%20coral%20sky%2C%20stylized%20stunning%20anime%20illustration%2C%20atmospheric%20and%20dreamy%2C%20wide%20banner%20composition%2C%20no%20text&width=1600&height=900&seq=hero-anime-banner&orientation=landscape"
          alt="妖精动漫网追番新世界城市插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          <span className="h-1.5 w-1.5 rounded-full bg-secondary-400"></span>
          今日更新 · 新番连载动态实时同步
        </span>
        <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          追番不停，<span className="text-secondary-300">更新不断</span>
        </h1>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-50/90 md:text-base">
          妖精动漫网专注新番更新追踪与追番日历，本周新番、连载动漫、完结动漫一手掌握。点开即看最新话，不再错过任何一集更新。
        </p>

        <form
          onSubmit={handleSearch}
          className="mt-8 flex w-full max-w-lg items-center gap-2 rounded-full border border-background-50/30 bg-background-50/95 p-1.5 pl-4 shadow-none"
        >
          <i className="ri-search-line text-base text-foreground-500"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索你想追的动漫..."
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            aria-label="搜索动漫"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-background-50">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl">12+</p>
            <p className="text-xs text-background-50/80">本周连载</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl">7天</p>
            <p className="text-xs text-background-50/80">每日更新</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl">8700万</p>
            <p className="text-xs text-background-50/80">累计播放</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl">98%</p>
            <p className="text-xs text-background-50/80">追更满意</p>
          </div>
        </div>
      </div>
    </section>
  );
}